import * as OrderTexts from '../../../../../../../intl'
import { form } from '../../../../formState'
import { Props } from '../../typings'

import { Email } from './components/Email'
import { Phone } from './components/Phone'

export function ContactInformation(props: Props) {
  return (
    <form.Fieldset>
      <form.SectionTitle variant="alternative">
        {OrderTexts.getContactInformationTitle()}
      </form.SectionTitle>

      <Phone {...props} />

      <Email {...props} />
    </form.Fieldset>
  )
}
